import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, Subject, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private updatePromoCodeAmount$ = new Subject<any>();
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  updatePromoCodeAmountObservable(): Observable<any> {
    return this.updatePromoCodeAmount$.asObservable();
  }

  updatePromoCodeAmount(amount: number): void {
    this.updatePromoCodeAmount$.next(amount);
  }

  setUltrasoundMeta(metadata: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/orders/set_metadata`, metadata)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  getUltrasoundOrderMetadata(orderId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/orders/get_metadata/${orderId}`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  addOrderService(data): Observable<any> {
    return this.http.post(`${this.apiUrl}/orders/add_item_invoice`, data)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  finalizeOrder(orderId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/orders/${orderId}/finalize-for-user`, {})
    .pipe(
      map(response => {
        return response;
      }),
      catchError(error => {
        return throwError(error);
      })
    );
  }
  

  sendComment(comment: string, orderId): Observable<any> {
    return this.http.put(`${this.apiUrl}/orders/${orderId}/comment`,{comment}).pipe(
      map(response => {
        return response;
      }),
      catchError(error => {
        return throwError(error);
      })
    );
  }

  replaceOrderService(data): Observable<any> {
    return this.http.post(`${this.apiUrl}/orders/replace_invoice`, data)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  checkPromoCode(promo: string, orderId: string | number): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('promo', promo);
    queryParams = queryParams.append('orderId', orderId.toString());
    return this.http.get(`${this.apiUrl}/promo/check_promo`, {params: queryParams})
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  getInvoiceDetails(invoiceId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/orders/invoice_details/${invoiceId}`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  getOrderServices(orderId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/orders/${orderId}/doctor-services`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  acceptForeignDoctorOrder(orderId, data): Observable<any> {
    return this.http.post(`${this.apiUrl}/orders/accept-foreigner-doctor-order/${orderId}`, data)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  checkForDoctra(invoiceId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/orders/${invoiceId}/check-for-doctra`, null)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }

  getOrderDoctorInfo(orderId: number): Observable<any> {
    const url = `${this.apiUrl}/orders/${orderId}/doctor`;
    return this.http.get<any>(url);
  }
}
